export default "__VITE_ASSET__358b083c__"